import { serverErrorMessage } from './wizardSteps';

// Options of a remote el-select that holds one saved record: the selected
// record (`selectedOption`, so its label shows before any search) followed by
// the results of the last search. `fetchOptions(query)` returns the request.
export default {
  data() {
    return {
      results: [],
      isSearching: false,
      searchCount: 0,
    };
  },
  computed: {
    options() {
      const selected = this.selectedOption ? [this.selectedOption] : [];
      const selectedIds = selected.map(({ id }) => id);
      return [
        ...selected,
        ...this.results.filter(({ id }) => !selectedIds.includes(id)),
      ];
    },
  },
  methods: {
    async search(query) {
      this.searchCount += 1;
      const current = this.searchCount;
      this.isSearching = true;
      try {
        const { data } = await this.fetchOptions(query);
        // A slower earlier search never replaces a later one.
        if (current === this.searchCount) this.results = data;
      } catch (error) {
        this.$notify({
          showClose: true,
          type: 'error',
          message: serverErrorMessage(error),
        });
      } finally {
        if (current === this.searchCount) this.isSearching = false;
      }
    },
    findOption(id) {
      return this.options.find((option) => option.id === id);
    },
  },
};
